import { LINE_SPACING_TYPE } from "./../ricos-content/index.js";
const lineSpacingModals = {
  spacingOptions: `${LINE_SPACING_TYPE}.modal`,
  customSpacing: `${LINE_SPACING_TYPE}.customSpacing`
};
export {
  lineSpacingModals
};
//# sourceMappingURL=consts.js.map
